var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Token } from '@/support/Token';
import { User } from '@/models/User';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { RouteNameEnum } from '@/router/RouteName';
let NoTenant = class NoTenant extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Page Not Found';
        this.url = 'mailto:helpdesk@mijnleerlijn.nl';
    }
    mounted() {
        if (Token.getAccessToken()) {
            new User()
                .current()
                .then((user) => {
                this.$store.dispatch('userAuthenticated', user);
                this.$router.push({ name: RouteNameEnum.HOME });
            })
                .catch(() => { });
        }
    }
};
NoTenant = __decorate([
    Component({
        components: {
            LanguageSwitch,
        },
    })
], NoTenant);
export default NoTenant;
